<div class="credit-card-icon" *ngIf="cardIconSource">
  <img src="{{cardIconSource}}"/>
</div>
<div class="icon-stack" *ngIf="!cardIconSource">
  <ion-icon name="card-outline" size="large" class="primary-icon"></ion-icon>
  <ion-icon name="save" size="small" class="secondary-icon-o" style="bottom:25%"></ion-icon>
</div>